export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_US_1M_44_1M_7_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_44_1m_7_99_usd',
			EUR: 'simple_premium_1m_39_1m_7_99_eur',
			GBP: 'simple_premium_1m_29_99_1m_14_39_gbp',
			AUD: 'simple_premium_1m_49_99_1m_21_59_aud',
			CAD: 'simple_premium_1m_49_99_1m_21_59_cad',
			DKK: 'simple_premium_1m_259_1m_103_2_dkk',
			SEK: 'simple_premium_1m_399_1m_159_2_sek',
			NOK: 'simple_premium_1m_399_1m_159_2_nok',
			BRL: 'simple_premium_1m_99_1m_31_2_brl',
			MXN: 'simple_premium_1m_499_1m_239_2_mxn',
			TRY: 'simple_premium_1m_999_1m_479_2_try',
			ARS: 'simple_premium_1m_39990_1m_19192_ars',
			COP: 'simple_premium_1m_119990_1m_58312_cop',
			CLP: 'simple_premium_1m_29990_1m_13992_clp',
		},
		primer: 'prd_kpa6dHjrPsvW',
	},
}
